import { useEffect, useState } from "react";
import { ShieldAlert, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { epaVerdict } from "@/lib/ust";

const CACHE = "fhp-epa-check-";
const OK = "fhp-epa-confirmed-";

async function lookup(site) {
  const key = CACHE + site.id;
  try { const c = JSON.parse(sessionStorage.getItem(key)); if (c && Date.now() - c.at < 6 * 3600e3) return c.data; } catch { /* none */ }
  if (!site.epaFacilityId && site.lat == null) return null;
  const data = await api.ustCheck(site.epaFacilityId ? { facilityId: site.epaFacilityId } : { lat: site.lat, lng: site.lng });
  try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data })); } catch { /* full */ }
  return data;
}

// Rechecks the saved station against the EPA list; blocks Log drop until the driver confirms a warning.
export function EpaCheck({ s, t, onBlock }) {
  const [found, setFound] = useState(null);
  const [ok, setOk] = useState(false);
  const okKey = `${OK}${s.activeSiteId}-${s.activeLabel}`;

  useEffect(() => {
    let live = true;
    setFound(null); setOk(sessionStorage.getItem(okKey) === "1");
    (async () => {
      const site = (await api.getSites().catch(() => [])).find((x) => x.id === s.activeSiteId);
      const tank = site?.tanks.find((x) => x.label === s.activeLabel);
      if (!tank) return;
      const data = await lookup(site).catch(() => null);
      if (live) setFound({ tank, data });
    })();
    return () => { live = false; };
  }, [s.activeSiteId, s.activeLabel]); // eslint-disable-line react-hooks/exhaustive-deps

  const v = found && epaVerdict(found.tank, found.data, t);
  const warn = v && v.level !== "ok";
  useEffect(() => { onBlock(!!warn && !ok); }, [warn, ok, onBlock]);
  if (!v) return null;
  if (!warn) return <div className="epa-ok" data-testid="epa-check-ok"><ShieldCheck size={14} />{v.text}</div>;
  const confirm = () => { sessionStorage.setItem(okKey, "1"); setOk(true); };
  return (
    <div className={`scan-message tone-${v.level} epa-warn`} data-testid="epa-check-warning">
      <div className="epa-warn-top"><ShieldAlert size={18} /><b>{v.text}</b></div>
      <div>{t("Don't drop into an out-of-service tank. Check the fill cap tag and with the store or dispatch.")}</div>
      {ok ? <div className="epa-confirmed" data-testid="epa-check-confirmed">{t("You confirmed this tank is in service.")}</div>
        : <button type="button" className="ghost-btn" onClick={confirm} data-testid="epa-check-confirm">{t("I checked — this tank is in service")}</button>}
    </div>
  );
}
